<template>
  <div>
    <b-row>
      <b-col 
        lg="4"
      >
        <b-select
          v-model="installateur"
          :options="[{text: 'Kies...',value: null}].concat(
            units.map(u => ({text: `${u.naam} (${u.aantal} units)`, 
                             value: u.adviesnummer,}))
          )"
          class="my-3"
          @change="getAfspraken"
        />
      </b-col>
    </b-row>
    <b-table 
      v-if="installateur && afspraken !== null"
      :caption="afsprakenUrl"
      :fields="[
        '#',
        {key:'label', label: 'Omschrijving', thStyle: { width: '320px' },},
      ].concat(afspraken_cols).concat(['acties'])" 
      :items="table_items" 
      small 
      hover 
      striped 
      dark
      bordered
    >
      <template #cell(#)="data">
        {{ data.index }}
      </template>
      <template #cell(index_jaar)="data">
        {{ data.item.index_jaar }}
      </template>
      <template #cell(acties)="data">
        <b-button-group v-if="data.item.details != null">
          <b-button 
            variant="success"
            size="sm"
            @click="() => data.item.id != null ? updateRow(data) : insertRow(data)"
          >
            <i :class="['fa', data.item.id != null ? 'fa-save' : 'fa-plus']" />
          </b-button>
          <b-button 
            v-if="data.item.id"
            :disabled="data.index === 0"
            variant="danger"
            size="sm"
            @click="() => deleteRow(data)"
          >
            <i class="fa fa-trash" />
          </b-button>
        </b-button-group>
      </template>
      <template #cell(label)="data">
        <div 
          v-if="data.item.label.kenmerk " 
          size="lg"
        >
          {{ data.item.label.kenmerk }} {{ data.item.label.adres }}
        </div>
        <b v-else>
          {{ data.item.label.toUpperCase() }}
        </b>
      </template>
      <template #cell()="data">
        <b-input-group v-if="data.item.details == null">
          <b-input 
            :value="standaard.details[data.field.key]" 
            disabled 
            size="sm"
          />
          <b-button 
            size="sm"
            @click="setupRow(data.index) "
          >
            <i class="fa fa-pencil " />
          </b-button>
        </b-input-group>
        <b-button 
          v-else-if="data.item.details[data.field.key] == null"
          size="sm"
          @click="$set(table_items[data.index].details, data.field.key, 0)"
        >
          + {{ data.field.key }}
        </b-button> 

        <b-input 
          v-else
          v-model.number="data.item.details[data.field.key]" 
          :placeholder="standaard.details[data.field.key].value"
          size="sm"
        />
      </template>
    </b-table>
  </div>
</template>
<script>
import { serviceMixin } from '@/mixins/serviceMixin';
import IndexBedrag from '../../components/financieel/IndexBedrag.vue';

export default {
    name: 'RelatieContractAfspraken',
    components: {
      IndexBedrag
    },
    mixins: [ serviceMixin],
    props: {
    },
    data() {
        return  {
          afspraken_cols: [
            {key: 'P1', label: 'Onderhoud'},
            {key: 'P2', label: 'Keuring'},
            {key: 'P3', label: 'SPL/GSM'},
            {key: 'P4', label: 'Advieskosten'},
            {key: 'CR', label: 'Correctieve reservering'},
            {key: 'C1', label: 'Voorrijden dag'},
            {key: 'C2', label: 'Voorrijden avond'},
            {key: 'C3', label: 'Arbeid dag'},
            {key: 'C4', label: 'Arbeid avond'},
            {key: 'C5', label: 'Arbeid zaterdag'},
            {key: 'C6', label: 'Arbeid zon/feestdag'},
          ] ,
          units: [],
          installateur: null,
          afspraken: null,
        }
    },
    computed: {
      afsprakenUrl() {
        return `/relatie/${this.$route.params.id}/installateur/${this.installateur}`
      },
      standaard: function() {
        if (this.afspraken != null ) return  {label: 'Standaard', details: this.getEmptyDetails(), ...this.afspraken.standaard};
        return {label: 'Standaard', details: this.getEmptyDetails()};
      },
      table_items() {
        return [
         this.standaard,
        ].concat(
          ...this.afspraken.units
        );
      }
    },
    watch: {},
    mounted () {
        this.getUnits();
    },
    methods: {
      setupRow(index) {
        this.$set(this.table_items[index],'details',{
            ...this.getEmptyDetails(),
        });
        this.$set(this.table_items[index],'indexering', null);
      },
      setIndexRow(row,index) {
        // set index based on afspraken_cols
        console.log(row,index);
        var fields = this.table_items[row].details;
        for (var field in fields) {
            fields[field].index = index;
        }
      },
      getUnits() {
        this.get(`/relatie/${this.$route.params.id}/installateurs`).then(
          response => {
            this.units = response.data.units;
          }
        )
      },
      getEmptyDetails() {
        return this.afspraken_cols.reduce((acc,cur) => ({...acc, [cur.key]: null}),{});
      },
      getAfspraken() {
        if (this.installateur == null) {
          this.afspraken = {};
          return;
        } 
        this.get(this.afsprakenUrl).then(
          response => {
            //console.log(response.data);
            this.afspraken = response.data;
          }
        )
      },
      insertRow(data) {
        console.log(data);
        this.post(this.afsprakenUrl, data.item).then(
          response => {
            console.log(response.data);
            if (data.index == 0) {
              this.$set(this.afspraken, 'standaard', response.data.result);
            } else {
              this.$set(this.afspraken.units, data.index-1, response.data.result);
            }
          }
        );
      },
     updateRow(data) {
      console.log(data.item);
        this.put(this.afsprakenUrl, data.item).then(
          response => {
            console.log(response.data);
            this.$set(this.data_table,data.index, response.data.result);
          }
        );
      },
      deleteRow(data) {
        console.log(data.item);
        this.deletePost(this.afsprakenUrl, data.item).then(
          response => {
            console.log(response.data);
            var afspraak = this.afspraken.units[data.index-1];
            this.$set( this.afspraken.units,data.index-1, {...afspraak, details: null, id: null, index_jaar: null});
          }
        );
      }
    },
}
</script>